"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelBattleDTO = exports.ReportBugDTO = exports.CreateBattleDTO = exports.GetBattleByUserDTO = exports.GetBattleDTO = exports.SearchBattleDTO = exports.BattleListDTO = exports.BattleDTO = exports.BattleSearchFilterDTO = exports.BattleOrderEnum = exports.Difficulty = exports.BattleContext = exports.Teams = void 0;
const class_validator_1 = require("class-validator");
const Goal_1 = require("./Goal");
const Pagination_1 = require("./Pagination");
var Teams;
(function (Teams) {
    Teams["None"] = "None";
    Teams["Zombies"] = "Zombies";
    Teams["Bandits"] = "Bandits";
    Teams["Team1"] = "Team1";
    Teams["Team2"] = "Team2";
    Teams["Team3"] = "Team3";
    Teams["Team4"] = "Team4";
})(Teams = exports.Teams || (exports.Teams = {}));
var BattleContext;
(function (BattleContext) {
    BattleContext["Quest"] = "Quest";
    BattleContext["PlaceAttackPvE"] = "PlaceAttackPvE";
    BattleContext["PlaceAttackPvP"] = "PlaceAttackPvP";
    BattleContext["Matchmaking"] = "Matchmaking";
    BattleContext["PlaceUpgrade"] = "PlaceUpgrade";
    BattleContext["Debug"] = "Debug";
})(BattleContext = exports.BattleContext || (exports.BattleContext = {}));
var Difficulty;
(function (Difficulty) {
    Difficulty["Easy"] = "Easy";
    Difficulty["Normal"] = "Normal";
    Difficulty["Hard"] = "Hard";
    Difficulty["VeryHard"] = "VeryHard";
    Difficulty["Impossible"] = "Impossible";
})(Difficulty = exports.Difficulty || (exports.Difficulty = {}));
var BattleOrderEnum;
(function (BattleOrderEnum) {
    BattleOrderEnum["startTime"] = "startTime";
})(BattleOrderEnum = exports.BattleOrderEnum || (exports.BattleOrderEnum = {}));
let BattleSearchFilterDTO = (() => {
    class BattleSearchFilterDTO extends Pagination_1.PaginationRequest {
    }
    __decorate([
        Pagination_1.CompatibleOrdering(BattleOrderEnum),
        __metadata("design:type", Object)
    ], BattleSearchFilterDTO.prototype, "order", void 0);
    return BattleSearchFilterDTO;
})();
exports.BattleSearchFilterDTO = BattleSearchFilterDTO;
class BattleDTO {
}
exports.BattleDTO = BattleDTO;
class BattleListDTO {
}
exports.BattleListDTO = BattleListDTO;
class SearchBattleDTO extends BattleDTO {
}
exports.SearchBattleDTO = SearchBattleDTO;
let GetBattleDTO = (() => {
    class GetBattleDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetBattleDTO.prototype, "battleId", void 0);
    return GetBattleDTO;
})();
exports.GetBattleDTO = GetBattleDTO;
let GetBattleByUserDTO = (() => {
    class GetBattleByUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetBattleByUserDTO.prototype, "userId", void 0);
    return GetBattleByUserDTO;
})();
exports.GetBattleByUserDTO = GetBattleByUserDTO;
let CreateBattleDTO = (() => {
    class CreateBattleDTO {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], CreateBattleDTO.prototype, "userIds", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], CreateBattleDTO.prototype, "mapName", void 0);
    __decorate([
        class_validator_1.IsEnum(Goal_1.GoalsNames),
        __metadata("design:type", String)
    ], CreateBattleDTO.prototype, "goalName", void 0);
    __decorate([
        class_validator_1.IsEnum(BattleContext),
        __metadata("design:type", String)
    ], CreateBattleDTO.prototype, "battleContext", void 0);
    return CreateBattleDTO;
})();
exports.CreateBattleDTO = CreateBattleDTO;
let ReportBugDTO = (() => {
    class ReportBugDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], ReportBugDTO.prototype, "battleId", void 0);
    return ReportBugDTO;
})();
exports.ReportBugDTO = ReportBugDTO;
let CancelBattleDTO = (() => {
    class CancelBattleDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], CancelBattleDTO.prototype, "battleId", void 0);
    return CancelBattleDTO;
})();
exports.CancelBattleDTO = CancelBattleDTO;
//# sourceMappingURL=Battle.js.map